import { Link } from "@hyperapp/router";
import { h } from "hyperapp";

import { inlineLoading } from "../inline-loading/inline-loading";
import mainNavbarCSS from "./main-navbar.css";

export const mainNavbar = ({ state: { location } }) => ({
  places: { loadingPlaces },
  unvisitedPlaces: { loadingUnvisitedPlaces },
  unvisitedPlacesNearby: { loadingUnvisitedPlacesNearby },
  scheduling: { sending },
}): JSX.Element => {
  const loadingSomething =
    loadingPlaces ||
    loadingUnvisitedPlaces ||
    loadingUnvisitedPlacesNearby ||
    sending;

  return (
    <nav
      class="bg-dark navbar navbar-dark navbar-expand-lg"
      style="background-color: #e3f2fd;"
    >
      <a class="navbar-brand" href="#">
        <span>
          <b>Contele</b> Locais
          {loadingSomething ? (
            inlineLoading()
          ) : (
            <span class={mainNavbarCSS.loadingPadding} />
          )}
        </span>
      </a>
      <button
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        class="navbar-toggler"
        data-target="#navbarSupportedContent"
        data-toggle="collapse"
        type="button"
      >
        <span class="navbar-toggler-icon" />
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class={"nav-item" + (location.pathname === "/" ? " active" : "")}>
            {Link(
              { class: "nav-link", to: `/` },
              <span>
                Todos
                {loadingPlaces ? (
                  inlineLoading()
                ) : (
                  <span class={mainNavbarCSS.loadingPadding} />
                )}
              </span>,
            )}
            {""}
            {location.pathname === "/" && (
              <span class="sr-only">(current)</span>
            )}
          </li>
          <li
            class={
              "nav-item" +
              (location.pathname === "/unvisited-places" ? " active" : "")
            }
          >
            {Link(
              { class: "nav-link", to: `/unvisited-places` },
              <span>
                Sem visitas
                {loadingUnvisitedPlaces ? (
                  inlineLoading()
                ) : (
                  <span class={mainNavbarCSS.loadingPadding} />
                )}
              </span>,
            )}
            {location.pathname === "/unvisited-places" && (
              <span class="sr-only">(current)</span>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
};
